<template>
        <div class="failOrderTip">
        <!-- <div class="title">
            <i class="el-icon-message-solid"></i>
        </div> -->
        <div class="content">
            <div class="title">{{ title }}</div>
            <div class="msg">{{ obj.msg }}</div>
            <!-- <span v-for="(item, index) in failOrderData" :key="index">{{ item }}&nbsp;</span> -->
            <div class="option" v-if="this.obj.type != 'sign'">
                <el-button @click="goMsg" size="mini">去处理</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { getAgent } from "@/api/Agent/Agent"
export default {
    name: 'SafeWEBFailOrderTip',
    props:{
        title:String,
        obj:{
            type: Object,
            default:()=>{},
        },
        newVue:{
            type: Object,
            default:()=>{}
        }
    },
    data() {
        return {
            
        };
    },

    mounted() {
        //TODO: 是否触发侧边栏待办信息重新获取
        let handle_command2 = ['dangers','check','checkCollect','system','constructionPlan']
        if(handle_command2.includes( this.obj.type)){
            console.log('重新获取待办信息');
           getAgent(this.newVue);//TODO: 重新获取代办信息
        }
    },

    methods: {
        async goMsg(){
            console.log(this.obj.type,'222222222222222222222222');

            let handle_command = {
                'meeting':()=>  this.newVue.$router.push({ path: '/safeTodoMeetingList' }),//TODO:会议消息
                'system':()=>   this.newVue.$router.push({ path: '/mailbox' }),//TODO:系统消息
                'dangerAssign':()=>  this.newVue.$router.push({ path: '/safeapprovedangersAcceptance' }),//TODO:隐患指派整改审核
                'dangers':()=>   this.newVue.$router.push({ path: '/safeapprovedangers' }),//TODO:隐患整改验收
                'check':()=>   this.newVue.$router.push({ path: '/safeapprovecheck' }),//TODO:安全检查审批
                'checkSign':()=>   this.newVue.$router.push({ path: '/checkCardRecords' }),//TODO:安全检查签到通知
                'safeCheck':()=>  this.newVue.$router.push({ path: '/securityMission' }),//TODO:安全检查
                'checkCollect':()=>  this.newVue.$router.push({ path: '/checkSummary' }),//TODO:安全检查汇总
                'dangersCheck':()=>  this.newVue.$router.push({ path: '/dangersMission' }),//TODO:隐患检查
                'officialOrdinary':()=>  this.newVue.$router.push({ path: '/safeOfficialLists' }),//TODO:普通公文
                'officialSecrecy':()=>  this.newVue.$router.push({ path: '/safeOfficialLists' }),//TODO:保密公文
                'riskCollect':()=>  this.newVue.$router.push({ path: '/saferiskSummary' }),//TODO:风险初审
                'certifies':()=>  this.newVue.$router.push({ path: '/safeTrainingCertificate' }),//TODO:证书管理
                // 'sign':()=>  this.newVue.$router.push({ path: '/checkCardRecords' }),//TODO:签到信息
                'constructionPlan':()=>  this.newVue.$router.push({ path: '/safeapproveConstruction' }),//TODO:生产计划审批
                'promiseOrdinary':()=>  this.newVue.$router.push({ path: '/safePromiseLists' }),//TODO:承诺书管理
                'riskIdetion':()=>  this.newVue.$router.push({ path: '/safeControlRecordsRisk' }),//TODO:承诺书管理
                'official':()=>  this.newVue.$router.push({ path: '/safeOfficialLists' }),//TODO:公文列表
                'vote':()=>  this.newVue.$router.push({ path: '/checkConfirmTicketRecords' }),//TODO:风险告知书
                'course':()=>  this.newVue.$router.push({ path: '/safeTrainingMyCourse' }),//TODO:我的课程

                
                
            }
            handle_command[this.obj.type]();
            
          
 
        }
    },
};
</script>

<style lang="scss" scoped>

.title{
    font-size: 18px;
}
.content{
    width: 100%;
    height: 100%;
    .msg{
        margin-top:5px;
        margin-bottom:5px;
        padding: 10px;
        box-sizing: border-box;
        font-size: 15px;
    }
    .option{
        display: flex;
        justify-content: flex-end;
    }
}
</style>